<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="reject_comment" />
        <v-card>
          <v-form class="pa-6" ref="form">
            <NewPublication
              :publication="publication"
              :mod-op_id="modOp_id"
              :disabled-form="disabledForm"
              @change-files="emitChangeFiles"
              @save-form="saveform_trigger = !saveform_trigger"
            />
            <v-row>
              <v-col cols="12">
                <h3 class="mt-15 mb-0">
                  {{ $t("title.bookAndChapterData") }}
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <h5>
                  {{ $t("form.bookandchapter.title") }}
                </h5>
                <v-row>
                  <v-col class="py-0">
                    <v-text-field
                        v-model="publication.bookAndChapter.title"
                        :label="$t('form.bookandchapter.title')"
                        outlined
                        :readonly="disabledForm"
                        :rules="rules.char_max_250"
                        :counter="250"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0">
                <h5>
                  {{ $t("form.bookandchapter.type") }}
                </h5>
                <v-row>
                  <v-col class="py-0">
                <v-select
                  outlined
                  v-model="publication.bookAndChapter.type"
                  :label="$t('form.bookandchapter.type')"
                  :rules="rules.fieldRequired"
                  :items="bookAndChapterTypes"
                  :readonly="disabledForm"
                  item-value="value"
                  item-text="text"
                />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <h5>{{ $t("editorial") }}</h5>
                <v-row>
                  <v-col class="py-0">
                <v-select
                  outlined
                  v-model="publication.bookAndChapter.editorial"
                  :label="$t('editorial')"
                  :rules="rules.fieldRequired"
                  :items="editorials"
                  :readonly="disabledForm"
                  item-value="id"
                  item-text="name"
                />
              </v-col>
            </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" class="py-0">
                <h5>
                  {{ $t("form.bookandchapter.num_pages") }}
                </h5>
                <v-row>
                  <v-col class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.num_pages"
                  :label="$t('form.bookandchapter.num_pages')"
                  required
                  :readonly="disabledForm"
                  outlined
                  :rules="rules.numPagesRules"
                  type="number"
                ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <h5>
                  {{ $t("form.bookandchapter.publication_date") }}
                </h5>
                <v-row>
                  <v-col class="py-0">
                <v-menu
                  v-model="menu_publication_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.bookAndChapter.publication_date"
                      :label="$t('form.bookandchapter.publication_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                      :rules="rules.fieldRequired"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.bookAndChapter.publication_date"
                    @input="menu_publication_date = false"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <h5>{{ $t("form.editors") }}</h5>
            <SelectPeopleList
              :disabled-form="disabledForm"
              :items-selected="publication.bookAndChapter.editors"
            />
            <h5>
              {{ $t("form.bookandchapter.editors_text") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.editors_text"
                  :label="$t('form.bookandchapter.editors_text')"
                  outlined
                  :readonly="disabledForm"
                  :rules="rules.char_max_300"
                  :counter="300"
                ></v-text-field>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.bookandchapter.book_location") }}
            </h5>
            <v-row>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.book_location.chapter"
                  :label="$t('form.bookandchapter.chapter')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.book_location.page_number"
                  :label="$t('form.bookandchapter.pageNumber')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.book_location.page_start"
                  :label="$t('form.bookandchapter.pageStart')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.book_location.page_end"
                  :label="$t('form.bookandchapter.pageEnd')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider />
            <UserFormActions
              form_name_text="new book and chapter"
              :form_name="form_name"
              :refForm="$refs.form"
              :object_type="object_type"
              :data="processData"
              :state="state"
              :saveform_trigger="saveform_trigger"
              @change-state="changeState"
              :paginated-form="true"
              class="text-center mt-6"
            />
          </v-form>
        </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import NewPublication from "./NewPublication";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import publication_model from "../../../mixins/model_utils/publication_model";
import publication_data from "../../../mixins/publication_data";

export default {
  mixins: [changeState, validationRules, publication_data, publication_model],
  components: {
    NewPublication,
    RejectCommentLayout,
    UserFormActions,
    SelectPeopleList
  },

  data: () => ({
    form_name: "newBookAndChapterForm",
    menu_publication_date: false,
    saveform_trigger: false,
    state: "",
    reject_comment: "",
    object_id: null,
    object_type: "publication",
    modOp_id: null,
  }),

  created() {
    this.getEditorials();
    this.getBookAndChapterTypes();
    if (this.updatePublication || this.updatePublicationForm) {
      this.getPublication();
    } else {
      if (this.$store.getters.user !== null) {
        this.loadDefaultAuthor();
      }
    }
  },

  computed: {
    updatePublicationForm() {
      return this.$route.params.id > -1 && !this.updatePublication;
    },
    updatePublication() {
      return this.$route.params.id > -1 && this.$route.meta.update;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      let data = {
        title: this.publication.title,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.object_id,
        data: {
          user: {
            publication: {
              title: this.publication.title,
              abstract: this.publication.abstract,
              acknowledgements: this.publication.acknowledgements,
              keywords: this.publication.keywords,
              doi: this.publication.doi,
              isbn: this.publication.isbn,
              authors_text: this.publication.authors_text,
              authorsrel: this.publication.authorsrel,
              research_areas: this.publication.research_areas.filter(area => Number.isInteger(area)),
              num_authors: this.publication.num_authors,
              links: this.publication.links,
              is_external: this.publication.is_external,
              hidden: this.publication.hidden,
              featured: this.publication.featured,
              language: this.publication.language,
              minerva_sync_option: this.publication.minerva_sync_option,
              regional: this.publication.regional,
              national: this.publication.national,
              international: this.publication.international,
              files: this.files,
              bookAndChapter: {
                title: this.publication.bookAndChapter.title,
                type: this.publication.bookAndChapter.type,
                editorial: this.publication.bookAndChapter.editorial,
                num_pages: this.publication.bookAndChapter.num_pages !== "" ? this.publication.bookAndChapter.num_pages : null,
                editors: this.publication.bookAndChapter.editors,
                book_location: this.publication.bookAndChapter.book_location,
                editors_text: this.publication.bookAndChapter.editors_text,
                publication_date: this.publication.bookAndChapter.publication_date
              }
            }
          }
        }
      };
      return data;
    }
  },

  methods: {
    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.normalizePublicationDefaults(this.publication);
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
